<template>
  <b-form-group
    label="Parametre Grubu"
    label-for="param_groups"
  >
    <validation-provider
      #default="{ errors }"
      name="Parametre Grubu"
      rules="required"
    >
      <b-form-input
        id="param_groups"
        v-model="dataItem.param_groups"
        placeholder="Parametre Grubu"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'ParamsGroup',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['params/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>

<style scoped>

</style>
